export default {
  STORAGE_USERNAME: 'user-username',
  STORAGE_USER_ID: 'user-user-id',
  STORAGE_NAME: 'user-name',
  STORAGE_EMAIL: 'user-email',
  STORAGE_COMPANY_NAME: 'user-company-name',
  STORAGE_COMPANY_DOC: 'user-company-doc',
  STORAGE_COMPANY_ZIPCODE: 'user-company-zipcode',
  STORAGE_COMPANY_ADDRESS: 'user-company-address',
  STORAGE_COMPANY_PHONE: 'user-company-phone',
  STORAGE_COMPANY_TRIAL: 'user-company-trial',
  STORAGE_COMPANY_ANALYSIS_COUNT: 'user-company-analysis-count',
  STORAGE_COMPANY_FARMS_COUNT: 'user-company-farms-count',
  STORAGE_COMPANY_ANALITICA: 'user-company-analitica',
  STORAGE_COMPANY_SENTINELA: 'user-company-sentinela',
  STORAGE_COMPANY_ID: 'user-company-id',
  STORAGE_COMPANY_CLIENT_ID: 'user-company-client-id',
  STORAGE_AUTHORITIES: 'user-authorities',
};
